import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function OurOffice() {
    return (
        <>
            <div className='relative flex flex-col gap-10 mt-20 items-center'>
                <div className="flex flex-col container max-w-7xl mx-auto text-right gap-8">
                    <div className="self-start text-5xl font-bold whitespace-nowrap text-zinc-900">
                        مكتبنا الإقليمي
                    </div>
                    <div className="mt-8 w-full text-lg text-zinc-900 max-md:max-w-full">
                        مؤسسة الخير تضرب جسور التعاون الإنساني عبر مكاتبها الدولية، حيث يعتبر
                        مكتبها الإقليمي الرئيسي في إسطنبول، تركيا، نقطة تلاقٍ للجهود الإنسانية
                        وتقديم الدعم للمحتاجين , بفضل وجود مكاتبها الدولية المنتشرة، تعزز مؤسسة
                        الخير الرؤية الإنسانية على مستوى عالمي وتضمن وصول المساعدات والدعم
                        بفاعلية وفورية إلى مناطق الحاجة حول العالم
                    </div>
                </div>
                <div className='bg-[#2F64D3] w-full h-[563px] border-b-[2px]'>
                    <div className='flex flex-col gap-10 items-center mt-10'>
                        <div className='font-bold text-4xl text-white'>المهام والاهداف</div>
                        <div className='grid grid-cols-4'>
                            <div className="flex flex-col self-stretch px-6 text-right text-white border-l border-dotted border-l-white border-opacity-20 max-w-[279px]">
                                <LazyLoadImage
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/95ba81d73afd1fc5f5535ff6a4f103339ebfaca1b00a51075da65438e0617ac5?"
                                    className="self-end w-24 aspect-square"
                                />
                                <div className="mt-6 text-lg font-bold leading-7 whitespace-nowrap">
                                    التقديم للمساعدة الإنسانية
                                </div>
                                <div className="mt-4 text-base tracking-wide leading-7">
                                    يهدف المكتب الإقليمي إلى تقديم المساعدة الإنسانية للأفراد والمجتمعات
                                    الذين يعانون من الأوضاع الصعبة والكوارث، بما في ذلك توفير الإغاثة
                                    العاجلة والدعم اللازم
                                </div>
                            </div>
                            <div className="flex flex-col self-stretch px-6 text-right text-white border-l border-dotted border-l-white border-opacity-20 max-w-[279px]">
                                <LazyLoadImage
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/95ba81d73afd1fc5f5535ff6a4f103339ebfaca1b00a51075da65438e0617ac5?"
                                    className="self-end w-24 aspect-square"
                                />
                                <div className="mt-6 text-lg font-bold leading-7 whitespace-nowrap">
                                    التقديم للمساعدة الإنسانية
                                </div>
                                <div className="mt-4 text-base tracking-wide leading-7">
                                    يهدف المكتب الإقليمي إلى تقديم المساعدة الإنسانية للأفراد والمجتمعات
                                    الذين يعانون من الأوضاع الصعبة والكوارث، بما في ذلك توفير الإغاثة
                                    العاجلة والدعم اللازم
                                </div>
                            </div>
                            <div className="flex flex-col self-stretch px-6 text-right text-white border-l border-dotted border-l-white border-opacity-20 max-w-[279px]">
                                <LazyLoadImage
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/95ba81d73afd1fc5f5535ff6a4f103339ebfaca1b00a51075da65438e0617ac5?"
                                    className="self-end w-24 aspect-square"
                                />
                                <div className="mt-6 text-lg font-bold leading-7 whitespace-nowrap">
                                    التقديم للمساعدة الإنسانية
                                </div>
                                <div className="mt-4 text-base tracking-wide leading-7">
                                    يهدف المكتب الإقليمي إلى تقديم المساعدة الإنسانية للأفراد والمجتمعات
                                    الذين يعانون من الأوضاع الصعبة والكوارث، بما في ذلك توفير الإغاثة
                                    العاجلة والدعم اللازم
                                </div>
                            </div>
                            <div className="flex flex-col self-stretch px-6 text-right text-white border-l border-dotted border-l-white border-opacity-20 max-w-[279px]">
                                <LazyLoadImage
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/95ba81d73afd1fc5f5535ff6a4f103339ebfaca1b00a51075da65438e0617ac5?"
                                    className="self-end w-24 aspect-square"
                                />
                                <div className="mt-6 text-lg font-bold leading-7 whitespace-nowrap">
                                    التقديم للمساعدة الإنسانية
                                </div>
                                <div className="mt-4 text-base tracking-wide leading-7">
                                    يهدف المكتب الإقليمي إلى تقديم المساعدة الإنسانية للأفراد والمجتمعات
                                    الذين يعانون من الأوضاع الصعبة والكوارث، بما في ذلك توفير الإغاثة
                                    العاجلة والدعم اللازم
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col w-[1200px] mx-auto relative bottom-32">
                    <div className="flex flex-col justify-center w-full rounded-2xl border-white border-solid border-[5px] max-md:max-w-full">
                        <div className="flex overflow-hidden relative flex-col justify-center items-center px-16 py-12 w-full min-h-[413px] max-md:px-5 max-md:max-w-full">
                            <LazyLoadImage
                                loading="lazy"
                                srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/5643/5f8b/12b9c9b1b746ae4719afe592701e0ae2?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ZMPjdN6kMU8zmzkZIXP~9P7XMe2N3aHGnnJ~WgwLC22Z6tMM6nPITznwgcVIqXWKEAeN-Q6iF4SmsoXU3--GOkizwai4PDhjo5mpFRV9dTL7cPtzXxxgClCMg556MIWa-TTMwULkRTqfFgGUz2~LEn4aJfQx695aNDXkXou~me9ikX6O8QrJd6oym~utmK-lIvs0Dw3wcO8CqqBfGycgdxZJrKX5435jWRpKdGdpfeFyCRFqYR-A7BLrD-h0Tj9o4cC4GHRjtuR3WeYq44j0myagxtKIeQOuLPLyRhDZK4SxlZ7GFDeflY9RRd89b2FnRYU9YKARFIer0~NhepZ-cA__"
                                className="object-cover absolute inset-0 size-full"
                            />
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/c83ecbed502003fc18617c9a4bea1ab850f67d03877cd07f7f5b0d3633611da2?"
                                className="mt-32 mb-24 aspect-square w-[54px] max-md:my-10"
                            />
                        </div>
                    </div>
                    <div className="px-6 py-12 mt-5 w-full bg-white rounded-lg max-md:px-5 max-md:max-w-full">
                        <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                            <div className="flex flex-col ml-5 w-[29%] max-md:ml-0 max-md:w-full">
                                <div className="flex gap-2 justify-end self-stretch pl-16 my-auto max-md:mt-10">
                                    <div className="flex justify-center items-center self-start px-3.5 w-12 h-12 bg-blue-500 aspect-square rounded-[30px]">
                                        <LazyLoadImage
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/dc3d78cf4a3c6e382fca78d9726820ef86c910a9a7ecca1e20aaa6ed3a276801?"
                                            className="w-full aspect-square"
                                        />
                                    </div>
                                    <div className="flex flex-col flex-1 text-base whitespace-nowrap">
                                        <div className="self-start font-bold text-neutral-900">
                                            البريد الإلكتروني
                                        </div>
                                        <div className="font-medium text-zinc-600">
                                            info@alkhairmiddleeast.org
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col ml-5 w-[30%] max-md:ml-0 max-md:w-full">
                                <div className="flex gap-2 justify-center self-stretch px-1 my-auto max-md:mt-10">
                                    <div className="flex justify-center items-center px-3.5 w-12 h-12 bg-blue-500 aspect-square rounded-[30px]">
                                        <LazyLoadImage
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/5af5e50844e6166921792e7217d0aa8e01b83819dabce1af595ab035792ba942?"
                                            className="w-full aspect-square"
                                        />
                                    </div>
                                    <div className="flex flex-col flex-1 text-base whitespace-nowrap">
                                        <div className="self-start font-bold text-neutral-900">
                                            هاتف رقم
                                        </div>
                                        <div className="flex gap-2 justify-start font-medium text-zinc-600">
                                            <div>+44 7360931094</div>
                                            <div>-</div>
                                            <div>+44 7360931094</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col w-[41%] max-md:ml-0 max-md:w-full">
                                <div className="flex grow gap-2 justify-between max-md:flex-wrap max-md:mt-10 max-md:max-w-full">
                                    <div className="flex justify-center items-center px-3 my-auto w-12 h-12 bg-blue-500 aspect-square rounded-[30px]">
                                        <LazyLoadImage
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/0d46418884330e6f313119f87db9b39043354349c679f23ff384d1009a2481b4?"
                                            className="w-full aspect-square"
                                        />
                                    </div>
                                    <div className="flex flex-col flex-1 text-base whitespace-nowrap">
                                        <div className="self-start font-bold text-neutral-900">
                                            مواعيد العمل
                                        </div>
                                        <div className="flex gap-2 justify-start items-start font-medium text-zinc-600">
                                            <div className="self-stretch text-right">
                                                من الساعة 10:00 ص حتى الساعة 04:00 م
                                            </div>
                                            <div>-</div>
                                            <div>يومياً عدا الجمعة </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="flex flex-col mt-20 gap-8">
                        <div className="w-full text-5xl font-bold text-right text-zinc-900 max-md:max-w-full">
                            فروعنا الآخرى
                        </div>
                        <div className="mt-8 w-full max-md:max-w-full">
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5 max-w-full">
                                <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                    <div className="flex flex-col grow p-2 w-full text-sm text-right bg-white rounded-lg border border-solid border-zinc-300 text-zinc-600 max-md:mt-5">
                                        <LazyLoadImage
                                            loading="lazy"
                                            srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/2630/2b98/5d3ac135e8f31a239c1e2f4c794469ae?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ZRk7EfqDtKBRT0QUZs3S~tqQvF5R-Vh5qTxnWEBMBmryvPdRTdLhddx-tBY3DkDR1UpdRyeKbITtYczTzjdEpGooAvSJZkCbuBD~I3yVMSMOJgDqA35u6uCar8wWL0R4-5cI1EJeegk1TVcreT0DUmkUcduMu4DdAZitBag4WYlEClHgGoM1V4zxs82PbxSJ4okbhdrOAJu7ey6~lPyV1Y9TizutfeyEi3cuQBUD91-T-FIhZIqizXUwefpRrnorkioIeAAOZ3Hzq7V6dBIRnnw8oa~0q~VHfk2bLOY9AmABIldtj7yoJloXNwKEhJCSs9gCKNldrYVINL7Cuw2vow__"
                                            className="w-full aspect-[1.35]"
                                        />
                                        <div className="flex flex-col p-2 mt-1">
                                            <div className="text-xl font-bold whitespace-nowrap text-zinc-900">
                                                لبنان - بيروت
                                            </div>
                                            <div className="mt-3">
                                                Restaurant &quot;Markova Cheshma&quot;- Prilep
                                                <br />
                                                9H8R+43P, Prilep, مقدونيا الشمالية
                                            </div>
                                            <div className="mt-3 whitespace-nowrap">مفتوح حتى 06:00 م.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                    <div className="flex flex-col grow p-2 w-full text-sm text-right bg-white rounded-lg border border-solid border-zinc-300 text-zinc-600 max-md:mt-5">
                                        <LazyLoadImage
                                            loading="lazy"
                                            srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/2630/2b98/5d3ac135e8f31a239c1e2f4c794469ae?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ZRk7EfqDtKBRT0QUZs3S~tqQvF5R-Vh5qTxnWEBMBmryvPdRTdLhddx-tBY3DkDR1UpdRyeKbITtYczTzjdEpGooAvSJZkCbuBD~I3yVMSMOJgDqA35u6uCar8wWL0R4-5cI1EJeegk1TVcreT0DUmkUcduMu4DdAZitBag4WYlEClHgGoM1V4zxs82PbxSJ4okbhdrOAJu7ey6~lPyV1Y9TizutfeyEi3cuQBUD91-T-FIhZIqizXUwefpRrnorkioIeAAOZ3Hzq7V6dBIRnnw8oa~0q~VHfk2bLOY9AmABIldtj7yoJloXNwKEhJCSs9gCKNldrYVINL7Cuw2vow__"
                                            className="w-full aspect-[1.35]"
                                        />
                                        <div className="flex flex-col p-2 mt-1">
                                            <div className="text-xl font-bold whitespace-nowrap text-zinc-900">
                                                لبنان - بيروت
                                            </div>
                                            <div className="mt-3">
                                                Restaurant &quot;Markova Cheshma&quot;- Prilep
                                                <br />
                                                9H8R+43P, Prilep, مقدونيا الشمالية
                                            </div>
                                            <div className="mt-3 whitespace-nowrap">مفتوح حتى 06:00 م.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                    <div className="flex flex-col grow p-2 w-full text-sm text-right bg-white rounded-lg border border-solid border-zinc-300 text-zinc-600 max-md:mt-5">
                                        <LazyLoadImage
                                            loading="lazy"
                                            srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/2630/2b98/5d3ac135e8f31a239c1e2f4c794469ae?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ZRk7EfqDtKBRT0QUZs3S~tqQvF5R-Vh5qTxnWEBMBmryvPdRTdLhddx-tBY3DkDR1UpdRyeKbITtYczTzjdEpGooAvSJZkCbuBD~I3yVMSMOJgDqA35u6uCar8wWL0R4-5cI1EJeegk1TVcreT0DUmkUcduMu4DdAZitBag4WYlEClHgGoM1V4zxs82PbxSJ4okbhdrOAJu7ey6~lPyV1Y9TizutfeyEi3cuQBUD91-T-FIhZIqizXUwefpRrnorkioIeAAOZ3Hzq7V6dBIRnnw8oa~0q~VHfk2bLOY9AmABIldtj7yoJloXNwKEhJCSs9gCKNldrYVINL7Cuw2vow__"
                                            className="w-full aspect-[1.35]"
                                        />
                                        <div className="flex flex-col p-2 mt-1">
                                            <div className="text-xl font-bold whitespace-nowrap text-zinc-900">
                                                لبنان - بيروت
                                            </div>
                                            <div className="mt-3">
                                                Restaurant &quot;Markova Cheshma&quot;- Prilep
                                                <br />
                                                9H8R+43P, Prilep, مقدونيا الشمالية
                                            </div>
                                            <div className="mt-3 whitespace-nowrap">مفتوح حتى 06:00 م.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                    <div className="flex flex-col grow p-2 w-full text-sm text-right bg-white rounded-lg border border-solid border-zinc-300 text-zinc-600 max-md:mt-5">
                                        <LazyLoadImage
                                            loading="lazy"
                                            srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/2630/2b98/5d3ac135e8f31a239c1e2f4c794469ae?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ZRk7EfqDtKBRT0QUZs3S~tqQvF5R-Vh5qTxnWEBMBmryvPdRTdLhddx-tBY3DkDR1UpdRyeKbITtYczTzjdEpGooAvSJZkCbuBD~I3yVMSMOJgDqA35u6uCar8wWL0R4-5cI1EJeegk1TVcreT0DUmkUcduMu4DdAZitBag4WYlEClHgGoM1V4zxs82PbxSJ4okbhdrOAJu7ey6~lPyV1Y9TizutfeyEi3cuQBUD91-T-FIhZIqizXUwefpRrnorkioIeAAOZ3Hzq7V6dBIRnnw8oa~0q~VHfk2bLOY9AmABIldtj7yoJloXNwKEhJCSs9gCKNldrYVINL7Cuw2vow__"
                                            className="w-full aspect-[1.35]"
                                        />
                                        <div className="flex flex-col p-2 mt-1">
                                            <div className="text-xl font-bold whitespace-nowrap text-zinc-900">
                                                لبنان - بيروت
                                            </div>
                                            <div className="mt-3">
                                                Restaurant &quot;Markova Cheshma&quot;- Prilep
                                                <br />
                                                9H8R+43P, Prilep, مقدونيا الشمالية
                                            </div>
                                            <div className="mt-3 whitespace-nowrap">مفتوح حتى 06:00 م.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OurOffice